module.exports = __webpack_public_path__ + "effd0b855d8215134c67e5de7109c23f.pdf";